import { render, staticRenderFns } from "./ChannelRuleEdit.vue?vue&type=template&id=4849274b&scoped=true"
import script from "./ChannelRuleEdit.vue?vue&type=script&lang=js"
export * from "./ChannelRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ChannelRuleEdit.vue?vue&type=style&index=0&id=4849274b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849274b",
  null
  
)

export default component.exports